<div class="d-flex justify-content-around mb-5">
  <p-photo-editor
    id="organismeLogo"
    [photo]="organismeLogo"
    [isSmall]="true"
    label="Charger un logo"
    (croppedImage)="onCroppedLogo($event)"
    (clearPhoto)="onClearLogo()"
  ></p-photo-editor>
  <p-photo-editor
    id="organismePhoto"
    [isSmall]="true"
    [photo]="organismePhoto"
    (croppedImage)="onCroppedPhoto($event)"
    (clearPhoto)="onClearPhoto()"
  ></p-photo-editor>
</div>

<form id="informations-client-form" class="px-4" [formGroup]="organismeForm">
  <div class="row">
    <div class="col-12 mb-3">
      <p-input
        [formControl]="this.organismeForm.controls.name"
        id="name"
        name="name"
        label="Nom de l'organisme"
        (input)="nameChanged($event)"
      ></p-input>
    </div>

    <div class="col-12 mb-3">
      <p-input
        [formControl]="this.organismeForm.controls.addressLine1"
        id="addressLine1"
        name="addressLine1"
        label="Adresse"
        (input)="addressLine1Changed($event)"
      ></p-input>
    </div>

    <div class="col-12 mb-3">
      <p-input
        [formControl]="this.organismeForm.controls.addressLine2"
        id="addressLine2"
        name="addressLine2"
        (input)="addressLine2Changed($event)"
      ></p-input>
    </div>

    <div class="col-12 mb-3">
      <p-input
        [formControl]="this.organismeForm.controls.addressLine3"
        id="addressLine3"
        name="addressLine3"
        (input)="addressLine3Changed($event)"
      ></p-input>
    </div>

    <div class="col-12 mb-3">
      <div class="d-flex justify-content-between">
        <p-input
          [formControl]="this.organismeForm.controls.postalCode"
          id="postalCode"
          name="postalCode"
          label="Code postal"
          [maxLengthNumber]="5"
          type="number"
          (input)="postalCodeChanged($event)"
        ></p-input>
        <p-input
          [formControl]="this.organismeForm.controls.city"
          id="city"
          name="city"
          label="Ville"
          (input)="cityChanged($event)"
        ></p-input>
      </div>
    </div>

    <div class="col-12">
      <div class="mb-3">
        <p-textarea
          [formControl]="this.organismeForm.controls.expertise"
          id="expertise"
          name="expertise"
          label="Domaine d'expertise"
          [maxLength]="2500"
          [showCounter]="true"
          (input)="expertiseChanged($event)"
        ></p-textarea>
      </div>
    </div>

    <div class="col-12">
      <div class="mb-3">
        <div class="mb-3">
          <p-input
            [formControl]="this.organismeForm.controls.titleService1"
            id="titleService1"
            name="titleService1"
            placeholder="Titre du service ou point fort 1"
            (input)="titleService1Changed($event)"
          ></p-input>
        </div>

        <p-textarea
          [formControl]="this.organismeForm.controls.descriptionService1"
          id="descriptionService1"
          name="descriptionService1"
          [maxLength]="2500"
          [showCounter]="true"
          (input)="descriptionService1Changed($event)"
        ></p-textarea>
      </div>
    </div>

    <div class="col-12">
      <div class="mb-3">
        <div class="mb-3">
          <p-input
            [formControl]="this.organismeForm.controls.titleService2"
            id="titleService2"
            name="titleService2"
            placeholder="Titre du service ou point fort 2"
            class="mb-3"
            (input)="titleService2Changed($event)"
          ></p-input>
        </div>
        <p-textarea
          [formControl]="this.organismeForm.controls.descriptionService2"
          id="descriptionService2"
          name="descriptionService2"
          [maxLength]="2500"
          [showCounter]="true"
          (input)="descriptionService2Changed($event)"
        ></p-textarea>
      </div>
    </div>
  </div>
</form>
